/**
 * This file ensures that React is properly loaded and available for Okta components
 * It fixes the "Cannot read properties of undefined (reading 'createContext')" error
 */

import React from 'react';

// Create a global React reference to ensure it's the same instance throughout the app
if (typeof window !== 'undefined' && !window.React) {
  window.React = React;
}

// Export React so it's available for other modules
export { React };

// This will be imported early to ensure React is loaded before Okta
